import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { AprovacaoResponse, RequisicaoBasica } from '../../types/RequisicaoBasica.type';
import { UsuarioContexto } from '../../types/UsuarioContexto.type';
import { Etapa, EtapaUpdateDTO, Workflow, WorkflowUpdateDTO } from '../../types/Workflow.type';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getRequisicoes(){

    return this.httpClient.get<RequisicaoBasica[]>(`${this.configService.getApiUrlRoot()}/workflows/requisicoes`);
  }

  getRequisicoesAprovar(){

    return this.httpClient.get<RequisicaoBasica[]>(`${this.configService.getApiUrlRoot()}/workflows/requisicoes/aprovacoes`);
  }

  getRequisicao(publicId: any) {

    return this.httpClient.get<RequisicaoBasica>(`${this.configService.getApiUrlRoot()}/workflows/requisicoes/${publicId}`)
  }

  postAprovar(corpo: any) {

    return this.httpClient.post<AprovacaoResponse>(`${this.configService.getApiUrlRoot()}/workflows/requisicoes/aprovacao`, corpo);
  }

  getUsuarioContexto() {

    return this.httpClient.get<UsuarioContexto>(`${this.configService.getApiUrlRoot()}/workflows/usuario/contexto`);
  }

  postExportRequisicao(publicId: any) {

    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/workflows/relatorios/exportar/${publicId}`, null, { responseType: 'blob'});
  }

  cancelarRequisicao(publicId: any) {

    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/workflows/requisicoes/cancelar/${publicId}`, null);
  }

  getWorkflows() {

    return this.httpClient.get<Workflow[]>(`${this.configService.getApiUrlRoot()}/workflows/`);
  }

  putWorkflow(workflow: WorkflowUpdateDTO) {

    return this.httpClient.put<Workflow>(`${this.configService.getApiUrlRoot()}/workflows/`, workflow);
  }

  getEtapasWorkflow(idWorkflow: string) {

    return this.httpClient.get<Etapa[]>(`${this.configService.getApiUrlRoot()}/workflows/etapas/workflow/${idWorkflow}`);
  }

  putEtapa(etapa: EtapaUpdateDTO) {

    return this.httpClient.put<Etapa>(`${this.configService.getApiUrlRoot()}/workflows/etapas/`, etapa);
  }
}
